/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React, { Fragment } from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { Box, Inline, xcss } from '@atlaskit/primitives';
import Tooltip from '@atlaskit/tooltip';
import { DefaultReactions } from '../../shared/constants';
import { EmojiButton } from '../EmojiButton';
import { ShowMore } from '../ShowMore';
import { revealStyle } from './styles';

/**
 * Test id for wrapper Selector div
 */
export var RENDER_SELECTOR_TESTID = 'render-selector';

/**
 * Delay for each emoji reveal animation, in ms
 */
var REVEAL_DELAY = 50;
var containerStyles = xcss({
  padding: 'space.050'
});
var separatorStyles = xcss({
  borderLeftColor: 'color.border',
  borderLeftStyle: 'solid',
  borderLeftWidth: 'border.width',
  marginInlineStart: 'space.050',
  marginInlineEnd: 'space.100',
  height: '24px',
  display: 'inline-block'
});
var Reveal = function Reveal(_ref) {
  var children = _ref.children,
    delay = _ref.delay,
    testId = _ref.testId;
  return jsx("div", {
    "data-testid": testId
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
    ,
    css: revealStyle
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    ,
    style: delay ? {
      animationDelay: "".concat(delay, "ms")
    } : undefined
  }, children);
};

/**
 * Reactions picker panel part of the <ReactionPicker /> component
 */
export var Selector = function Selector(_ref2) {
  var emojiProvider = _ref2.emojiProvider,
    onMoreClick = _ref2.onMoreClick,
    onSelection = _ref2.onSelection,
    showMore = _ref2.showMore,
    _ref2$pickerQuickReac = _ref2.pickerQuickReactionEmojiIds,
    pickerQuickReactionEmojiIds = _ref2$pickerQuickReac === void 0 ? DefaultReactions : _ref2$pickerQuickReac;
  /**
   * Render the default emoji icon
   * @param emoji emoji item
   * @param index location of the emoji in the array
   */
  var renderEmoji = function renderEmoji(emoji, index) {
    var _emoji$id;
    return jsx(Reveal, {
      delay: index * REVEAL_DELAY,
      key: (_emoji$id = emoji.id) !== null && _emoji$id !== void 0 ? _emoji$id : emoji.shortName,
      testId: RENDER_SELECTOR_TESTID
    }, jsx(Tooltip, {
      content: emoji.shortName
    }, jsx(EmojiButton, {
      emojiId: emoji,
      emojiProvider: emojiProvider,
      onClick: onSelection
    })));
  };
  return jsx(Inline, {
    alignBlock: "center",
    xcss: containerStyles
  }, pickerQuickReactionEmojiIds ? pickerQuickReactionEmojiIds.map(renderEmoji) : null, showMore ? jsx(Fragment, null, jsx(Box, {
    xcss: separatorStyles
  }), jsx(Reveal, {
    delay: DefaultReactions.length * REVEAL_DELAY
  }, jsx(ShowMore, {
    key: "more",
    onClick: onMoreClick
  }))) : null);
};